import getTime from './get-time';

export { getTime };

export default getTime;
